import React from 'react';

const LoadingState = ({ message }) => (
  <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 p-8">
    <div className="text-center">
      <div className="w-16 h-16 bg-red-smdd rounded-full flex items-center justify-center mx-auto mb-6">
        <svg
          className="animate-spin h-8 w-8 text-black"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </div>
      <h3 className="text-xl font-baijamjuree font-bold text-black mb-2">
        Processing...
      </h3>
      <p className="text-gray-700 font-baijamjuree mb-4">{message}</p>
      {message?.includes('files') && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
          <p className="text-sm text-yellow-800 font-baijamjuree">
            📄 We're analyzing your presentation and compressing video files to
            optimize upload speed. This may take a few moments.
          </p>
        </div>
      )}
    </div>
  </div>
);

export default LoadingState;
